import { useEffect, useState } from "react";
import "../css/CarbonBar.css";

function CarbonBar() {
  const [co2, setCo2] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const calculateCO2 = () => {
      let transferSize = 0;

      const navigation =
        performance.getEntriesByType("navigation")[0];

      if (navigation) {
        transferSize = navigation.transferSize;
      }

      // Browser transferSize available nahi deta
      if (!transferSize || transferSize <= 0) {
        transferSize = 500 * 1024;
      }

      // Bytes -> MB
      const sizeMB = transferSize / (1024 * 1024);

      // Approximate CO2 per MB
      const CO2_PER_MB = 0.36;

      let result = sizeMB * CO2_PER_MB;

      if (result < 0.1) {
        result = 0.1;
      }

      result = Math.round(result * 10) / 10;

      setCo2(result);
    };

    setTimeout(calculateCO2, 1000);
  }, []);

  const progress =
    co2 !== null
      ? Math.max(20, Math.min(100, 100 - co2 * 10))
      : 70;

  return (
    <>
      {/* CO2 BAR */}
      <div className="carbon-bar">

        <div className="carbon-text">
          This website emits an average of{" "}
          <strong>
            {co2 !== null ? `${co2} g of CO₂` : "calculating..."}
          </strong>{" "}
          per page,{" "}
          <button
            className="carbon-link"
            onClick={() => setShowModal(true)}
          >
            find out more
          </button>
        </div>

        <div className="carbon-line">
          <div
            className="carbon-progress"
            style={{ width: `${progress}%` }}
          ></div>
        </div>

      </div>


      {/* POPUP */}
      {showModal && (
        <div
          className="carbon-modal"
          onClick={() => setShowModal(false)}
        >
          <div
            className="carbon-modal-content"
            onClick={(e) => e.stopPropagation()}
          >

            <button
              className="carbon-close"
              onClick={() => setShowModal(false)}
            >
              ×
            </button>

            <h3>Website Carbon Emissions</h3>

            <p>
              Every time a web page is loaded, energy is
              consumed by servers, networks and your device.
            </p>

            <p>
              We estimate the carbon emissions based on
              the amount of data transferred.
            </p>

            <div className="carbon-result">
              <strong>
                {co2 !== null ? `${co2} g CO₂` : "Calculating..."}
              </strong>

              <span>
                estimated per page view
              </span>
            </div>

            <p className="carbon-note">
              This is an approximate estimate. Actual
              emissions depend on the data centre, network,
              device and electricity source.
            </p>

          </div>
        </div>
      )}
    </>
  );
}

export default CarbonBar;